import { useMemo } from 'react';

import { VStack } from 'ui/Layout';
import { Text } from 'ui/Typography';

import { Sankey } from '../../generated-api';
import { isFinancialSankey } from '../../utils/sankey';
import DiagramsCards from '../DiagramsCards';

type Props = {
  templateSankeys: Sankey[];
  isLoading: boolean;
  selectedDiagramId: number | undefined;
  onClick: (id: number) => void;
  onDoubleClick: (id: number) => void;
};

const TemplateDiagramsView: React.FC<Props> = ({
  templateSankeys,
  ...otherProps
}) => {
  const { financialSankeys, otherSankeys } = useMemo(
    () => ({
      financialSankeys: templateSankeys.filter((t) => isFinancialSankey(t)),
      otherSankeys: templateSankeys.filter((t) => !isFinancialSankey(t)),
    }),
    [templateSankeys]
  );

  return (
    <VStack alignItems="stretch" gap={3}>
      <Text fontSize="xl">Financial statement templates</Text>
      <DiagramsCards diagrams={financialSankeys} {...otherProps} />
      <Text fontSize="xl" pt={4}>
        Other templates
      </Text>
      <DiagramsCards diagrams={otherSankeys} {...otherProps} />
    </VStack>
  );
};

export default TemplateDiagramsView;
